import linkifyHtml from 'linkify-html'

export default {
  computed: {
    vHTML: app => (text, params) => {
      if (!process.client) {
        return text
      }
      const parser = new DOMParser()
      const html = parser.parseFromString(text, 'text/html')
      const htmlLinks = html.querySelectorAll('a')
      htmlLinks.forEach((tag, idx, _nodeList) => {
        if (tag.getAttribute(':to')) {
          const rawTo = tag
            .getAttribute(':to')
            .replace(/(['"])?([a-z0-9A-Z_]+)(['"])?:/g, '"$2": ')
          let to = ''
          try {
            to = JSON.parse(rawTo)
          } catch (err) {
            return
          }
          if (!to) {
            return
          }
          _nodeList[idx].setAttribute('href', app.$router.resolve(to).href)
          _nodeList[idx].setAttribute('target', '_blank')
        }
      })
      return linkifyHtml(html.body.outerHTML, {target: '_blank'})
    }
  }
}
